var _path, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomPinSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H36C38.2091 0 40 1.79086 40 4V36C40 38.2091 38.2091 40 36 40H4C1.79086 40 0 38.2091 0 36V4Z",
    fill: "#1C53EC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1161_11792",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 7,
    width: 26,
    height: 26
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 8.5,
    width: 23,
    height: 23,
    fill: "#D9D9D9",
    stroke: "white",
    strokeWidth: 3
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1161_11792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 29.4382C19.7655 29.4382 19.5308 29.3962 19.2961 29.3124C19.0614 29.2286 18.8519 29.1029 18.6675 28.9352C17.5778 27.9294 16.6138 26.9487 15.7756 25.9931C14.9374 25.0375 14.2375 24.1113 13.6759 23.2144C13.1143 22.3175 12.6868 21.4542 12.3934 20.6243C12.1001 19.7945 11.9534 19.0024 11.9534 18.248C11.9534 15.7334 12.7622 13.73 14.38 12.238C15.9977 10.746 17.8712 10 20.0002 10C22.1293 10 24.0027 10.746 25.6204 12.238C27.2382 13.73 28.0471 15.7334 28.0471 18.248C28.0471 19.0024 27.9004 19.7945 27.607 20.6243C27.3136 21.4542 26.8861 22.3175 26.3245 23.2144C25.7629 24.1113 25.063 25.0375 24.2248 25.9931C23.3866 26.9487 22.4226 27.9294 21.333 28.9352C21.1486 29.1029 20.939 29.2286 20.7043 29.3124C20.4696 29.3962 20.2349 29.4382 20.0002 29.4382ZM20.0002 20.0586C20.5534 20.0586 21.027 19.8616 21.421 19.4676C21.8149 19.0737 22.0119 18.6001 22.0119 18.0468C22.0119 17.4936 21.8149 17.02 21.421 16.6261C21.027 16.2321 20.5534 16.0351 20.0002 16.0351C19.447 16.0351 18.9734 16.2321 18.5794 16.6261C18.1855 17.02 17.9885 17.4936 17.9885 18.0468C17.9885 18.6001 18.1855 19.0737 18.5794 19.4676C18.9734 19.8616 19.447 20.0586 20.0002 20.0586Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomPinSelected);
export default __webpack_public_path__ + "static/media/custom-pin-selected.d387d6a13b27f993c4ac6c8474d27ee6.svg";
export { ForwardRef as ReactComponent };